import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SecretariaService from '../../../../../services/secretaria-auth';



const Secretarias = () => {
    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [horarios, setHorarios] = useState("");
    const [telefone, setTelefone] = useState("");
    const [secretario, setSecretario] = useState("");
    const [sigla, setSigla] = useState("");
    const [email, setEmail] = useState("");
    const [competencias, setCompetencias] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await SecretariaService.cadastro({
                nome: nome,
                endereco: endereco,
                horarios: horarios,
                telefone: telefone,
                secretario: secretario,
                sigla: sigla,
                email: email,
                competencias: competencias
            })
            if (local.data["_id"]) {
                alert("Secretaria cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(local.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setEndereco("");
        setHorarios("");
        setTelefone("");
        setSecretario("");
        setSigla("");
        setEmail("");
        setCompetencias("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="endereco">
                                <FloatingLabel
                                    label="Endereço"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="horarios">
                                <FloatingLabel
                                    label="Horários de Funcionamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="horarios"
                                        value={horarios}
                                        onChange={e => setHorarios(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Telefone de Atendimento (2554-XXXX)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="telefone"
                                        value={telefone}
                                        onChange={e => setTelefone(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="secretario">
                                <FloatingLabel
                                    label="Secretário(a)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="secretario"
                                        value={secretario}
                                        onChange={e => setSecretario(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="sigla">
                                <FloatingLabel
                                    label="Sigla"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="sigla"
                                        value={sigla}
                                        onChange={e => setSigla(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Competências"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        aria-rowcount={10}
                                        name="competencias"
                                        value={competencias}
                                        onChange={e => setCompetencias(e.target.value)}
                                        as="textarea"
                                        rows={20} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/institucional/secretaria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Secretaria cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/institucional/secretaria/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Secretarias
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/institucional/secretaria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Secretarias;